<template>
  <svg
    :id="uniqueId"
    :class="classnames"
    :fill="`currentColor`"
    :height="getHeight"
    :viewBox="`0 0 22 18`"
    :width="getWidth"
  >
  <g transform="translate(-510.000000, -240.000000)">
    <g id="mail" transform="translate(510.000000, 240.000000)">
      <path d="M19,0 C20.6522847,0 22,1.34771525 22,3 L22,15 C22,16.6522847 20.6522847,18 19,18 L3,18 C1.34771525,18 0,16.6522847 0,15 L0,3 C0,1.34771525 1.34771525,0 3,0 L19,0 Z M20,4.92 L11.5734623,10.8192319 C11.2291422,11.060256 10.7708578,11.060256 10.4265377,10.8192319 L10.4265377,10.8192319 L2,4.921 L2,15 C2,15.5477153 2.45228475,16 3,16 L19,16 C19.5477153,16 20,15.5477153 20,15 L20,4.92 Z M19,2 L3,2 C2.61200142,2 2.27189207,2.22696691 2.10652962,2.55404305 L11,8.77934444 L19.8934704,2.55404305 C19.7281079,2.22696691 19.3879986,2 19,2 Z" />
    </g>
  </g>
  </svg>
</template>

<script>
  import { bem } from '@/mixins/bem.js'

  const namespace = 'svg-icon-mail'

  export default {
    name: 'SvgIconMail',
    components: {},
    mixins: [ bem ],
    props: {
      height: {
        default: '18',
        type: String
      },
      width: {
        default: '22',
        type: String
      }
    },
    data () {
      return {}
    },
    computed: {
      getHeight: function () {
        const height = `${this.height}px`

        return height
      },
      getWidth: function () {
        const width = `${this.width}px`

        return width
      }
    },
    created: function () {
      this.namespace = namespace
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/svgs/SvgIconMail.vue